export default "__VITE_ASSET__BnzVKr0H__"